import { NgModule } from '@angular/core';
import { CustomCartEventBuilder } from './custom-cart-event.builder';

@NgModule({})
export class CustomCartEventModule {
  // tslint:disable-next-line:variable-name
  constructor(_customCartEventBuilder: CustomCartEventBuilder) {}
}
